import * as api from '../../services/exceptConfig'

export const FETCH_EXCEPT_CONFIG= 'FETCH_EXCEPT_CONFIG';




export const fetchExceptConfig = (params, pagination, sort, extra) => {

    return {
        type: FETCH_EXCEPT_CONFIG,
        payload: {
            promise: api.findExceptConfig(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/exceptConfig.js